import { css } from 'styled-components'

export const BlackText = css`
  color: ${({ theme }) => theme.Colors.textColor};
`

export const GrayText = css`
  color: ${({ theme }) => theme.Colors.textColorGray};
`

export const LightGrayText = css`
  color: ${({ theme }) => theme.Colors.textColorLightGray};
`
